export default "/fonts/vendor/simple-line-icons/Simple-Line-Icons.woff2?3826fa1cb2348dd93948a50cbd2b8fb6";